const routes = [
  {
    path: '/student/EvaluationRequestManagement',
    component: () =>
      import(
        '@/views/student/evaluation-request-managment/EvaluationRequestManagmentWrapper.vue'
      ),
    children: [
      {
        path: '',
        name: 'EvaluationRequestManagement',
        component: () =>
          import(
            '@/views/student/evaluation-request-managment/EvaluationRequestManagement.vue'
          ),
      },
      {
        path: '/student/evaluationrequestmanagement/history/:studentReferralId',
        name: 'EvaluationRequestHistory',
        component: () =>
          import(
            '@/views/student/evaluation-request-managment/EvaluationRequestHistory.vue'
          ),
      },
      {
        path: 'historical/:client',
        name: 'EvaluationAppointmentHistorical',
        component: () =>
          import('@/views/student/quotes/AppointmentHistoricalWrapper.vue'),
      },
      {
        path: '/student/evaluationrequestmanagement/appoinmentcoordination',
        name: 'AppoinmentCoordinationEval',
        component: () =>
          import(
            '@/views/student/evaluation-request-managment/AppoinmentCoordination.vue'
          ),
      },
      {
        path: '/student/evaluationrequestmanagement/ProvisionalRemedyRequest',
        name: 'student-provisionalRemedyRequest',
        component: () =>
          import('@/components/student/ProvisionalRemedyRequest.vue'),
      },
    ],
  },
];

export default routes;
